import React, { useState } from 'react'
import { Dropdown } from '@chegg-ui/dropdown'
import { getHeader as getWorksCitedHeader } from '@chegg-wt/core/utils/formattingExport'
import { CitationCopy } from '@chegg-wt/core/types/copy'
import { sortOptionsList } from '@chegg-wt/core/state/bibliography/constants'
import { SortKey } from '@chegg-wt/core/constants/projects'
import * as Styled from './styled'
import { SORT_BY_BUTTON } from './testIds'

interface CitationListHeaderProps {
  enableSort: boolean
  copy: CitationCopy
  style: string
  onSortSelect: (sortKey: SortKey) => void
  defaultSortKey: SortKey
}

export const CitationListHeaderContainer: React.FC<CitationListHeaderProps> = ({
  enableSort,
  copy,
  style,
  onSortSelect,
  defaultSortKey,
}) => {
  const [sortKey, setSortKey] = useState<SortKey>(defaultSortKey)

  const onSelectValue = (value: SortKey) => {
    setSortKey(value)
    onSortSelect(value)
  }

  return (
    <Styled.CitationItemsHeaderContainer>
      <div />
      <Styled.WorksCitedText>{getWorksCitedHeader(style)}</Styled.WorksCitedText>
      <Styled.SortByDropdownContainer>
        <Dropdown
          options={enableSort ? sortOptionsList : [sortOptionsList[2]]}
          onSelectValue={onSelectValue}
          value={sortKey}
          labelText={copy.sortBy}
          inputId="sort-citations"
          width="210px"
          data-test={SORT_BY_BUTTON}
        />
      </Styled.SortByDropdownContainer>
    </Styled.CitationItemsHeaderContainer>
  )
}
